<template>
  <el-dialog
    class="dialog"
    title="新增发票抬头"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    width="500px"
  >
    <div class="dialog-body">
      <div class="edit-tip">新增的发票抬头用于增值服务类开票。</div>

      <!-- 普票表单 -->
      <el-form
        ref="generalForm"
        :model="form"
        :rules="rules"
        label-suffix="："
        label-width="170px"
        label-position="right"
        size="mini"
      >
        <el-form-item label="单位名称" prop="companyName">
          <el-input
            v-model.trim="form.companyName"
            maxlength="50"
            show-word-limit
            placeholder="请输入单位名称"
          />
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="companyTaxNo">
          <el-input
            v-model.trim="form.companyTaxNo"
            maxlength="50"
            show-word-limit
            placeholder="请输入纳税人识别号"
          />
        </el-form-item>
        <el-form-item label="单位地址">
          <el-input
            v-model.trim="form.companyAddress"
            maxlength="50"
            show-word-limit
            placeholder="请输入单位地址"
          />
        </el-form-item>
        <el-form-item label="单位电话">
          <el-input
            v-model.trim="form.companyMobile"
            placeholder="请输入单位电话"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="开户银行">
          <el-input
            v-model.trim="form.companyBankName"
            placeholder="请输入开户银行"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input
            v-model.trim="form.companyBankAccount"
            placeholder="请输入银行账号"
            maxlength="30"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="收票人手机号" prop="employeeMobile">
          <el-input
            v-model.trim="form.employeeMobile"
            placeholder="请输入收票人手机号"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="收票人邮箱" prop="employeeEmail">
          <el-input
            v-model.trim="form.employeeEmail"
            placeholder="请输入收票人邮箱"
            maxlength="50"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="本次是否填写专票信息">
          <el-radio-group v-model="form.invoiceType">
            <el-radio
              :label="invoiceTypeDict.SPECIAL_PAPER_INVOICE.value"
            >是</el-radio>
            <el-radio
              :label="invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value"
            >否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <!-- 专票表单 -->
      <el-form
        v-if="showSpecial"
        ref="specialForm"
        :model="form"
        :rules="rules"
        label-suffix="："
        label-position="right"
        label-width="170px"
      >
        <el-form-item label="单位名称" prop="companyName">
          <el-input
            v-model.trim="form.companyName"
            maxlength="50"
            show-word-limit
            placeholder="请输入单位名称"
          />
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="companyTaxNo">
          <el-input
            v-model.trim="form.companyTaxNo"
            maxlength="50"
            show-word-limit
            placeholder="请输入纳税人识别号"
          />
        </el-form-item>
        <el-form-item label="注册地址" prop="companyAddress">
          <el-input
            v-model.trim="form.companyAddress"
            maxlength="50"
            show-word-limit
            placeholder="请输入注册地址"
          />
        </el-form-item>
        <el-form-item label="注册电话" prop="companyMobile">
          <el-input
            v-model.trim="form.companyMobile"
            placeholder="请输入注册电话"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="开户银行" prop="companyBankName">
          <el-input
            v-model.trim="form.companyBankName"
            placeholder="请输入开户银行"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="银行账号" prop="companyBankAccount">
          <el-input
            v-model.trim="form.companyBankAccount"
            placeholder="请输入银行账号"
            maxlength="30"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="收票人姓名" prop="employeeName">
          <el-input
            v-model.trim="form.employeeName"
            placeholder="请输入收票人姓名"
            maxlength="10"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="收票人手机号" prop="employeeMobile">
          <el-input
            v-model.trim="form.employeeMobile"
            placeholder="请输入收票人手机号"
            maxlength="20"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="收票人邮箱" prop="employeeEmail">
          <el-input
            v-model.trim="form.employeeEmail"
            placeholder="请输入收票人邮箱"
            maxlength="50"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="邮寄地址" prop="receiveAddress">
          <el-input
            v-model.trim="form.receiveAddress"
            placeholder="请输入邮寄地址"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="上传专票证明附件" prop="attachmentId">
          <upload
            ref="upload"
            :props-data="{
              bizType: 'invoice_paper',
              attachmentType: 'invoice_paper',
              groupIdBefore: form.attachmentId,
              beforeUpload: beforeUpload,
              onSuccess: groupId => (form.attachmentId = groupId),
              onCompleteDelete: () => (form.attachmentId = '')
            }"
          >
            <div slot="tip" class="important-tip m-t-10">
              支持：jpg、png、bmp、jpeg，图片大小不超过5M，只可上传1个
            </div>
          </upload>
          <download-file
            class="download-file"
            download-link="/resources/专用发票信息证明.docx"
          >
            <span class="text-primary">下载专票证明模版</span>
          </download-file>
        </el-form-item>
      </el-form>
    </div>

    <div class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="submitInvoice">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 组件
import Upload from '@/components/Upload'
import DownloadFile from '@/components/DownloadFile'
// 工具
import { formValid } from 'jczh-ui'
// 字典
import { invoiceTypeDict, isCompanyDict } from '@/dictionary/financial'
import { addInvoiceApi } from '@/api/financial/invoice'
import { mapState } from 'vuex'

/**
 * @description 发票抬头编辑弹窗
 */
export default {
  name: 'CustomInvoiceEditDialog',

  components: { Upload, DownloadFile },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      invoiceTypeDict,

      // 发票表单
      form: {
        // 单位名称,
        companyName: '',
        // 纳税人识别号
        companyTaxNo: '',
        // 发票id
        id: '',
        // (普票)单位地址/(专票)注册地址
        companyAddress: '',
        // (普票)单位电话/(专票)注册电话
        companyMobile: '',
        // 开户银行
        companyBankName: '',
        // 开户银行账号
        companyBankAccount: '',
        // 收票人姓名
        employeeName: '',
        // 收票人手机
        employeeMobile: '',
        // 收票人邮箱
        employeeEmail: '',
        // 邮寄地址
        receiveAddress: '',
        // 附件id
        attachmentId: '',
        // 发票类型
        invoiceType: invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value,
        // 是否企业信息
        isCompany: isCompanyDict.COMPANY.value
      },
      rules: {
        companyName: {
          required: true,
          message: '请输入单位名称',
          trigger: 'blur'
        },
        companyTaxNo: {
          required: true,
          message: '请输入纳税人识别号',
          pattern: /^[a-zA-Z\d]*$/g,
          trigger: 'blur'
        },
        companyAddress: {
          required: true,
          message: '请输入注册地址',
          trigger: 'blur'
        },
        companyMobile: {
          required: true,
          message: '请输入注册电话号码',
          trigger: 'blur'
        },
        companyBankName: {
          required: true,
          message: '请输入开户银行',
          trigger: 'blur'
        },
        companyBankAccount: {
          required: true,
          message: '请输入开户银行账号',
          trigger: 'blur'
        },
        employeeName: {
          required: true,
          message: '请输入收票人姓名',
          trigger: 'blur'
        },
        employeeMobile: [
          {
            required: true,
            message: '请输入收票人手机号码',
            trigger: 'blur'
          },
          formValid.mobileRegular
        ],
        employeeEmail: [
          {
            required: true,
            message: '请输入收票人邮箱地址',
            trigger: 'blur'
          },
          formValid.emailRegular
        ],
        receiveAddress: {
          required: true,
          message: '请输入邮寄地址',
          trigger: 'blur'
        },
        attachmentId: {
          required: true,
          message: '请上传附件',
          trigger: 'blur'
        }
      }
    }
  },

  computed: {
    ...mapState('company', ['companyId']),

    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },

    // 是否填写专票信息
    showSpecial() {
      return (
        this.form.invoiceType === invoiceTypeDict.SPECIAL_PAPER_INVOICE.value
      )
    }
  },

  methods: {
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.dialogVisible = false
      this.$refs.generalForm.resetFields()
      if (this.$refs.specialForm) {
        this.$refs.specialForm.resetFields()
      }
    },

    /**
     * 表单校验
     */
    async formValid() {
      try {
        const validList = [await this.$refs.generalForm.validate()]
        if (this.showSpecial) {
          validList.push(this.$refs.specialForm.validate())
        }
        const validateResult = await Promise.all(validList)
        return !!validateResult.every(item => item)
      } catch (e) {
        return false
      }
    },

    /**
     * 提交表单
     */
    async submitInvoice() {
      try {
        const valid = await this.formValid()
        if (!valid) return
        await this.$confirm('确定提交吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        // 如果当前用户为企业员工，则isCompany为1，否则为0
        this.form.isCompany = this.companyId
          ? isCompanyDict.COMPANY.value
          : isCompanyDict.PERSONAL.value

        const res = await addInvoiceApi(this.form)
        this.$message.success(res?.data?.message || '保存成功')
        this.$emit('afterSubmit')
        this.closeDialog()
      } catch (e) {
        console.error('提交表单失败', e)
        if (e?.data?.message) this.$message.error(e.data.message)
      }
    },

    /**
     * 附件上传前的验证函数
     * @param file
     * @returns {boolean}
     */
    beforeUpload(file) {
      const isImg =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'
      const isLt5M = file.size / 1024 / 1024 <= 5
      if (!isImg) {
        this.$message.error('上传文件类型错误，请依照说明信息上传正确的文件')
      }
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!')
      }
      return isLt5M && isImg
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-body {
  width: 100%;
  box-sizing: border-box;
  padding: 0 48px 0 24px;
  position: relative;

  .edit-tip {
    color: $text-third-color;
    margin-bottom: 16px;
  }

  ::v-deep .el-form {
    .el-form-item {
      margin-bottom: 16px;
    }
  }

  .download-file {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    color: $primary-color;
    font-size: 12px;
  }
}

.dialog-footer {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 24px;
  text-align: right;
  border-top: 1px solid $info-fourth-color;
}
</style>
